// @flow
import { StyleSheet, TextStyle, ViewStyle } from "react-native";
import { screenHeight } from "../../../utils/dimensions";
import { colors, fontSizes } from "../../../constants/styles";

const buttonContainer: ViewStyle = {
  height: 60,
  marginHorizontal: 10,
  borderRadius: 3,
  justifyContent: "center",
};

const buttonText: TextStyle = {
  fontSize: screenHeight < 600 ? fontSizes.x14 : fontSizes.x16,
  fontFamily: "HelveticaNeue-Medium",
  textAlign: "center",
};

export const bottomButtonStyles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "flex-end",
  },
  buttonContainer: {
    ...buttonContainer,
    backgroundColor: colors.albaikBrightRed,
  },
  buttonText: {
    ...buttonText,
    color: colors.white,
  },
  disabledStyles: {
    opacity: 0.5,
  },
});

export const whiteBottomButtonStyles = StyleSheet.create({
  buttonContainer: {
    ...buttonContainer,
    backgroundColor: colors.white,
  },
  buttonText: {
    ...buttonText,
    color: colors.maroon,
  },
});

export const tposButtonStyles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
  },
  disabledContainer: {
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.whiteAlpha(0.25),
  },
  buttonContainer: {
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.dullWhite,
  },
  iconContainer: {
    marginRight: 15,
    alignItems: "center",
    justifyContent: "center",
  },
  buttonText: {
    textAlign: "left",
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.cedar,
  },
});
